import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import styles from './PortfolioModalQuestions.module.scss';
import PortfolioQuestion from '../../../MainInfoItem/PortfolioItem/PortfolioQuestion';
import EmptyState from '../../../UI/EmptyState/EmptyState';
import { ReactComponent as CommentsIcon } from '../../../../assets/svg/commentPost.svg';
import { ReactComponent as DotPost } from '../../../../assets/svg/dotPost.svg';
import '@github/relative-time-element';

interface Question {
  id: string | number;
  question: string;
  answers?: Array<{
    id: string | number;
    answer: string;
    user?: {
      name: string;
      image_profile?: string;
    };
  }>;
  created_at?: string;
}

interface PortfolioModalQuestionsProps {
  questions: Question[];
  myPerson: boolean;
  portfolioId: string | number;
  userData: any;
}

const PortfolioModalQuestions: React.FC<PortfolioModalQuestionsProps> = ({
  questions,
  myPerson,
  portfolioId,
  userData
}) => {
  const [showQAndA, setShowQAndA] = useState(false);

  const handleAskButton = () => {
    setShowQAndA(true);
  };

  return (
    <>
      <div className={styles.info_questions}>
        <div className={styles.info_questions_header}>
          <MessageCircle size={18} />
          <span>
            {questions.length > 0
              ? `${questions.length} ${questions.length === 1 ? 'pregunta' : 'preguntas'}`
              : 'Preguntas'}
          </span>
        </div>
        <div className={styles.info_questions_list}>
          {questions.length > 0 ? (
            questions.map((question, index) => (
              <div key={question.id || index} className={styles.question_item}>
                <div className={styles.question_header}>
                  <p className={styles.question_text}>{question.question}</p>
                  {question.created_at && (
                    <div className={styles.question_meta}>
                      <DotPost width={20} height={20} />
                      <span className={styles.question_time}>
                        <relative-time lang="es" tense="past" datetime={question.created_at}></relative-time>
                      </span>
                    </div>
                  )}
                </div>
                {question.answers && question.answers.length > 0 ? (
                  <div className={styles.question_answers}>
                    {question.answers.map((answer) => (
                      <div key={answer.id} className={styles.question_answer}>
                        {answer.user?.image_profile && (
                          <img
                            src={answer.user.image_profile}
                            alt={answer.user.name}
                            className={styles.answer_image}
                          />
                        )}
                        <p className={styles.answer_text}>{answer.answer}</p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className={styles.no_answer}>No hay respuestas aún.</p>
                )}
              </div>
            ))
          ) : (
            <EmptyState 
              title="Nadie hizo preguntas ¡Hacé la primera!" 
              icon={<CommentsIcon width={30} height={30} />} 
              isPortfolio 
            />
          )}
        </div>
        {!myPerson && (
          <button className={styles.ask_button} onClick={handleAskButton}>
            Preguntar
          </button>
        )}
      </div>

      {showQAndA && (
        <PortfolioQuestion
          closeModal={() => setShowQAndA(false)}
          portfolioId={portfolioId}
          userData={userData}
        />
      )}
    </>
  );
};

export default PortfolioModalQuestions;

